export enum StudentType {
    ADMIN = "admin",
    STUDENT = "student"
}
